import { useMediaQuery } from "@shared/hooks/useMediaQuery";
import { ModalSize } from "@ui-kit/overlays/Modal/Modal.props";
import breakpoints from "@shared/theme/props/breakpoints";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import Text from "@ui-kit/typography/Text/Text.web";

import { PropsWithChildren } from "react";

const { xs } = breakpoints;

export type DefaultModalContainerProps = PropsWithChildren<{
  title: string;
  isOpen: boolean;
  onClose: () => void;
  firstButton?: JSX.Element;
  secondButton?: JSX.Element;
  footerContainer?: JSX.Element;
  bannerElement?: JSX.Element;
  footerText?: string;
  modalHeight?: string;
  modalSize?: ModalSize;
  noFooter?: boolean;
  footerDivider?: boolean;
  customWidth?: string;
  titleIcon?: JSX.Element;
}>;

/**
 * @deprecated Use Modal from ui-kit instead
 */
export const DefaultModalContainer: React.FC<DefaultModalContainerProps> = ({
  title,
  isOpen,
  onClose,
  firstButton = <></>,
  secondButton = <></>,
  footerContainer = undefined,
  children,
  bannerElement,
  footerText,
  modalSize = "2xl",
  noFooter,
  titleIcon = <></>,
}): JSX.Element => {
  const [isSmallerThanXs] = useMediaQuery(`(max-width: ${xs}px)`);

  return (
    <Modal
      scrollBehavior="inside"
      size={isSmallerThanXs ? "full" : modalSize}
      isOpen={isOpen}
      isCentered
      data-testid="default-modal-container-wrapper"
      onClose={onClose}
    >
      <Modal.Header data-testid="default-modal-header" onClose={onClose}>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" data-testid="default-modal-title">
            {titleIcon}
            {title}
          </Flex>
        </Flex>
      </Modal.Header>

      <Modal.Body>
        {bannerElement && (
          <Box
            ml="-24px"
            mr="-24px"
            mt="-24px"
            mb="xl"
            data-testid="default-modal-banner-element"
          >
            {bannerElement}
          </Box>
        )}
        {children}
      </Modal.Body>

      {!noFooter && (
        <Modal.Footer data-testid="default-modal-footer">
          {footerContainer || (
            <Flex
              width="100%"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Flex data-testid="default-modal-footer-first-button">
                {firstButton}
              </Flex>
              <Flex textAlign="right" direction="column">
                <Text fontWeight="bold" pb="xs">
                  {footerText}
                </Text>
                <span data-testid="default-modal-footer-second-button">
                  {secondButton}
                </span>
              </Flex>
            </Flex>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default DefaultModalContainer;
